import loadable from '@loadable/component';

export const SearchJobsPageLoadable = loadable(
  () => import('./SearchJobsPage'),
  { resolveComponent: (module) => module.SearchJobsPage },
);
